import { PaginatedApiResponse } from "@/types/api.types";
import baseApi from "./RootBaseApi";
import { IBerthCategoryData } from "@/types/berth-category.types";

export const BerthCategoryService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCategories: builder.query<
      PaginatedApiResponse<IBerthCategoryData[]>,
      { page?: number; limit?: number; search?: string; harbor_id?: string }
    >({
      query: (params = {}) => ({
        url: "categories",
        method: "GET",
        params,
      }),
      providesTags: ["BerthCategories"],
    }),

    getCategoryById: builder.query<IBerthCategoryData, string>({
      query: (id) => ({
        url: `categories/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "BerthCategories", id }],
    }),

    createCategory: builder.mutation<
      IBerthCategoryData,
      Partial<IBerthCategoryData> | FormData
    >({
      query: (data) => {
        return {
          url: "categories",
          method: "POST",
          data: data,
        };
      },
      invalidatesTags: ["BerthCategories"],
    }),

    updateCategory: builder.mutation<
      IBerthCategoryData,
      { id: string; data: Partial<IBerthCategoryData> }
    >({
      query: ({ id, data }) => ({
        url: `categories/${id}`,
        method: "PATCH",
        data: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "BerthCategories", id },
      ],
    }),

    deleteCategory: builder.mutation<void, string>({
      query: (id) => ({
        url: `categories/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["BerthCategories"],
    }),
  }),
});

export const {
  useGetCategoriesQuery,
  useGetCategoryByIdQuery,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
} = BerthCategoryService;
